import {
  GET_SALES,
  GET_SALES_ONE,
  GET_SALES_SUCCESS,
  GET_SALES_FAIL,
  DELETE_SALES,
  DELETE_SALES_SUCCESS,
  DELETE_SALES_FAIL,
  UPDATE_SALES,
  UPDATE_SALES_SUCCESS,
  UPDATE_SALES_FAIL,
  ADD_NEW_SALES,
  ADD_SALES_SUCCESS,
  ADD_SALES_FAIL,
  SALES_LOADING,
  SALES_RESET,
} from "./actionType";

export const resetSalesState = (actionType) => ({
  type: SALES_RESET,
  payload: { actionType },
});

export const getSalesSuccess = (actionType, data) => ({
  type: GET_SALES_SUCCESS,
  payload: { actionType, data },
});

export const getSalesFail = (actionType, error) => ({
  type: GET_SALES_FAIL,
  payload: { actionType, error },
});

export const getSales = data => ({
  type: GET_SALES,
  payload: data,
});

export const getSalesOne = (data) => ({
  type: GET_SALES_ONE,
  payload: data,
});

export const getSalesLoading = () => ({
  type: SALES_LOADING
});

export const deleteSales = data => ({
  type: DELETE_SALES,
  payload: data,
});

export const deleteSalesSuccess = data => ({
  type: DELETE_SALES_SUCCESS,
  payload: data,
});

export const deleteSalesFail = error => ({
  type: DELETE_SALES_FAIL,
  payload: error,
});

export const updateSales = data => ({
  type: UPDATE_SALES,
  payload: data,
});

export const updateSalesFail = error => ({
  type: UPDATE_SALES_FAIL,
  payload: error,
});

export const updateSalesSuccess = data => ({
  type: UPDATE_SALES_SUCCESS,
  payload: data,
});

export const addNewSales = data => ({
  type: ADD_NEW_SALES,
  payload: data,
});

export const addSalesSuccess = data => ({
  type: ADD_SALES_SUCCESS,
  payload: data,
});

export const addSalesFail = error => ({
  type: ADD_SALES_FAIL,
  payload: error,
});